import React from "react";

const Progression = () => {
    return ( 
        <svg
            className="mx-2"
            width="20"
            height="20"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                opacity="0.12"
                x="0.65625"
                y="0.5"
                width="28.0664"
                height="28.0664"
                rx="14.0332"
                fill="#244F96"
            />
            <path
                d="M23.8922 10.1482V14.6482C23.8922 15.0982 23.5922 15.3982 23.1422 15.3982C22.6922 15.3982 22.3922 15.0982 22.3922 14.6482V11.9482L16.5422 17.7982C16.2422 18.0982 15.7922 18.0982 15.4922 17.7982L12.2672 14.5732L7.16721 19.6732C7.01721 19.8232 6.86721 19.8982 6.64221 19.8982C6.41721 19.8982 6.26721 19.8232 6.11721 19.6732C5.81721 19.3732 5.81721 18.9232 6.11721 18.6232L11.7422 12.9982C12.0422 12.6982 12.4922 12.6982 12.7922 12.9982L16.0172 16.2232L21.3422 10.8982H18.6422C18.1922 10.8982 17.8922 10.5982 17.8922 10.1482C17.8922 9.69819 18.1922 9.39819 18.6422 9.39819H23.1422C23.2172 9.39819 23.3672 9.39819 23.4422 9.47319C23.5922 9.54819 23.7422 9.69819 23.8172 9.84819C23.8922 9.92319 23.8922 10.0732 23.8922 10.1482Z"
                fill="#00A3BE"
            />
        </svg>
    )
}

export default Progression;